import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from '@emailjs/browser';
import { supabase } from '../supabaseClient';
import "./Home.css";

// Import carousel images
import carouselImg1 from "../assets/courosalimg1.jpg";
import carouselImg3 from "../assets/courosalimg3.jpg";

// Import doctors images
import doctorImage from "../assets/doctor-image.jpg";
import doctorImg from "../assets/Doctorimg.jpeg";

// Superior general's message
import superiorMessageImage from "../assets/Vattakarai Counselling Centre.jpg";

// Import gallery images
import Gallery1 from "../assets/Gallery1.jpg";
import Gallery2 from "../assets/Gallery2.JPG";
import Gallery3 from "../assets/Gallery3.jpg";
import Gallery4 from "../assets/Gallery4.jpg";
import Gallery5 from "../assets/Gallery5.jpg";
import Gallery6 from "../assets/Gallery6.jpg";
import Gallery7 from "../assets/Gallery7.jpg";
import Gallery8 from "../assets/Gallery8.jpg";
import Gallery9 from "../assets/Gallery9.jpg";
import Gallery10 from "../assets/Gallery10.jpg";
import Gallery11 from "../assets/Gallery11.jpg";
import Gallery12 from "../assets/Gallery12.JPG";
import Gallery13 from "../assets/Gallery13.JPG";
import Gallery14 from "../assets/Gallery14.JPG";
import Gallery15 from "../assets/Gallery15.JPG";
import Gallery16 from "../assets/Gallery16.JPG";

const EMAILJS_SERVICE_ID = 'service_x0yq0x9';
const EMAILJS_TEMPLATE_ID = 'template_u98iw5v';
const EMAILJS_USER_ID = 'hLcC56cE274aJ2bs8';

const Home = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [currentGallery, setCurrentGallery] = useState(0);
  const [showAllGallery, setShowAllGallery] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [testimonialsLoading, setTestimonialsLoading] = useState(true);
  const [usingSampleData, setUsingSampleData] = useState(false);
  const [autoSlide, setAutoSlide] = useState(true);
  
  // Upcoming Events State
  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);
  const [eventsError, setEventsError] = useState(null);
  
  // Google Calendar Configuration (from Programs.js)
  const CALENDAR_ID = "f8f1db5ec8d5e7cd07c41071fd985261966ef07918026388e23139beb13978f6@group.calendar.google.com";
  const CALENDAR_URL = "https://calendar.google.com/calendar/embed?src=f8f1db5ec8d5e7cd07c41071fd985261966ef07918026388e23139beb13978f6%40group.calendar.google.com&ctz=Asia%2FKolkata";
  const API_KEY = "AIzaSyD6bZ45YyaAG1MC2u5gtTnPT1Y7ea00zYk";

  // Services list
  const services = [
    "Individual Counselling in Nagercoil",
    "Couples Counselling & Marriage Therapy",
    "Child & Adolescent Counselling",
    "Family Counselling Services",
    "Career Counselling & Guidance",
    "Stress Management Therapy",
    "Depression Counselling",
    "Anxiety Counselling",
    "Grief Counseling & Bereavement Support",
    "Mandala Art Therapy Workshop",
    "Relationship Issues Counselling",
    "Addiction Counselling",
    "Anger Management Therapy",
    "Pre-marital Counselling",
    "Sexual Counselling",
    "LGBTQ+ Affirmative Counselling"
  ];

  // Sample testimonials
  const sampleTestimonials = [
    {
      id: 1,
      name: "Priya Sharma",
      comment: "The counselling sessions helped me overcome my anxiety. Highly recommended for anyone struggling with mental health.",
      rating: 5,
      position: "Teacher"
    },
    {
      id: 2,
      name: "Rajesh Kumar",
      comment: "Professional and compassionate service. The therapist truly understands and provides practical solutions.",
      rating: 5,
      position: "Business Owner"
    },
    {
      id: 3,
      name: "Anjali Nair",
      comment: "Mandala therapy was transformative for my stress management. A unique and effective approach.",
      rating: 4,
      position: "Student"
    },
    {
      id: 4,
      name: "Vikram Reddy",
      comment: "Career guidance sessions helped me find my true calling. Professional approach with personalized attention.",
      rating: 5,
      position: "Software Engineer"
    },
    {
      id: 5,
      name: "Meena Iyer",
      comment: "The couple's counselling saved our marriage. We learned to communicate effectively and rebuild trust.",
      rating: 5,
      position: "Homemaker"
    }
  ];

  // Gallery images array
  const galleryImages = [
    { id: 1, src: Gallery1, alt: "Counselling Session 1" },
    { id: 2, src: Gallery2, alt: "Counselling Session 2" },
    { id: 3, src: Gallery3, alt: "Counselling Session 3" },
    { id: 4, src: Gallery4, alt: "Counselling Session 4" },
    { id: 5, src: Gallery5, alt: "Counselling Session 5" },
    { id: 6, src: Gallery6, alt: "Counselling Session 6" },
    { id: 7, src: Gallery7, alt: "Counselling Session 7" },
    { id: 8, src: Gallery8, alt: "Counselling Session 8" },
    { id: 9, src: Gallery9, alt: "Counselling Session 9" },
    { id: 10, src: Gallery10, alt: "Counselling Session 10" },
    { id: 11, src: Gallery11, alt: "Counselling Session 11" },
    { id: 12, src: Gallery12, alt: "Counselling Session 12" },
    { id: 13, src: Gallery13, alt: "Counselling Session 13" },
    { id: 14, src: Gallery14, alt: "Counselling Session 14" },
    { id: 15, src: Gallery15, alt: "Counselling Session 15" },
    { id: 16, src: Gallery16, alt: "Counselling Session 16" }
  ];

  // Label at top
  const stats = [
    { number: "15+", label: "Years of Experience" },
  ];

  // Appointment form state
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: '',
    timePreference: 'Morning',
    sessionType: 'Offline'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  // Navigation handler
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Load reviews from Supabase
  useEffect(() => {
    loadAllReviews();
  }, []);

  // NEW: Fetch Google Calendar Events (from Programs.js)
  useEffect(() => {
    const fetchGoogleCalendarEvents = async () => {
      try {
        setEventsLoading(true);
        setEventsError(null);
        
        const now = new Date();
        const timeMin = now.toISOString();
        const timeMax = new Date(now.getTime() + 90 * 24 * 60 * 60 * 1000).toISOString();
        
        const calendarUrl = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(CALENDAR_ID)}/events?key=${API_KEY}&timeMin=${timeMin}&timeMax=${timeMax}&singleEvents=true&orderBy=startTime`;
        
        const response = await fetch(calendarUrl, {
          method: 'GET',
          headers: { 'Accept': 'application/json' }
        });
        
        if (response.status === 403) {
          setEventsError("Calendar access restricted. Please check API configuration.");
          return;
        }
        
        if (!response.ok) {
          throw new Error(`API Error: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.error) {
          setEventsError(`Google Calendar Error: ${data.error.message}`);
          return;
        }
        
        if (!data.items || data.items.length === 0) {
          setEvents([]);
          setEventsLoading(false);
          return;
        }
        
        const formattedEvents = data.items.map((event, index) => {
          const start = event.start.dateTime || event.start.date;
          const end = event.end.dateTime || event.end.date;
          const eventDate = new Date(start);
          
          const getTimeString = () => {
            if (event.start.date) return "All Day";
            const startTime = new Date(start).toLocaleTimeString('en-IN', { 
              hour: '2-digit', 
              minute: '2-digit',
              hour12: true 
            });
            const endTime = new Date(end).toLocaleTimeString('en-IN', { 
              hour: '2-digit', 
              minute: '2-digit',
              hour12: true 
            });
            return `${startTime} - ${endTime}`;
          };
          
          const getDateString = () => {
            return eventDate.toLocaleDateString('en-IN', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            });
          };
          
          const description = event.description || "Join us for this transformative event. Details will be provided upon registration.";
          const location = event.location || "Servite Counselling Centre, Nagercoil";
          
          const extractRegistrationLink = (desc) => {
            if (!desc) return "#";
            const formRegex = /https:\/\/docs\.google\.com\/forms\/[^\s<>"]+/gi;
            const linkMatch = desc.match(formRegex);
            return linkMatch && linkMatch[0] ? linkMatch[0] : "#";
          };
          
          const cleanDescription = (desc) => {
            if (!desc) return "Join us for this transformative event. Details will be provided upon registration.";
            let cleaned = desc.replace(/<[^>]*>/g, '');
            cleaned = cleaned.replace(/https?:\/\/[^\s]+/g, '');
            cleaned = cleaned.replace(/\n+/g, ' ');
            cleaned = cleaned.trim();
            
            if (cleaned.length > 100) {
              return cleaned.substring(0, 100) + "...";
            }
            
            return cleaned || "Join us for this transformative event. Details will be provided upon registration.";
          };
          
          return {
            id: event.id || `event-${index}`,
            title: event.summary || "Upcoming Workshop",
            date: getDateString(),
            time: getTimeString(),
            description: cleanDescription(event.description),
            registrationLink: extractRegistrationLink(event.description),
            location: location,
            image: "/images/programs/mandala.jpg" // Default image
          };
        });
        
        setEvents(formattedEvents);
        setEventsLoading(false);
        
      } catch (error) {
        console.error("Error fetching calendar events:", error);
        setEventsLoading(false);
        setEventsError("Unable to load events at this time.");
      }
    };
    
    fetchGoogleCalendarEvents();
    const interval = setInterval(fetchGoogleCalendarEvents, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const loadAllReviews = async () => {
    try {
      setTestimonialsLoading(true);
      
      try {
        const { data, error } = await supabase
          .from('reviews')
          .select('*')
          .order('created_at', { ascending: false })
          .limit(10);

        if (error) throw error;
        
        if (data && data.length > 0) {
          setReviews(data);
          setUsingSampleData(false);
        } else {
          throw new Error("No reviews found in database");
        }
      } catch (supabaseError) {
        setReviews(sampleTestimonials);
        setUsingSampleData(true);
      }
      
    } catch (error) {
      setReviews(sampleTestimonials);
      setUsingSampleData(true);
    } finally {
      setTestimonialsLoading(false);
    }
  };

  // Testimonial auto-slide
  useEffect(() => {
    let interval;
    if (reviews.length > 0 && autoSlide) {
      interval = setInterval(() => {
        setCurrentTestimonial((prev) => (prev + 1) % reviews.length);
      }, 5000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [reviews.length, autoSlide]);

  // Gallery auto-slide
  useEffect(() => {
    let interval;
    if (galleryImages.length > 0 && autoSlide && !showAllGallery) {
      interval = setInterval(() => {
        setCurrentGallery((prev) => (prev + 1) % galleryImages.length);
      }, 4000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [galleryImages.length, autoSlide, showAllGallery]);

  const carouselSlides = [
    {
      image: carouselImg1,
      alt: "Professional Mental Health Counselling Services",
      title: "Expert Mental Health Care & Therapy",
      subtitle: "Professional counselling services tailored to your unique needs and circumstances with certified therapists",
      cta: "Start Your Healing Journey",
      link: "/services"
    },
    {
      image: carouselImg3,
      alt: "Safe Confidential Therapy Environment",
      title: "Safe & Confidential Environment",
      subtitle: "Experience compassionate care in a trusted, private setting designed for your comfort and healing",
      cta: "Discover Our Approach",
      link: "/about"
    }
  ];

  // Auto slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselSlides.length) % carouselSlides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Gallery navigation
  const nextGallery = () => {
    setCurrentGallery((prev) => (prev + 1) % galleryImages.length);
  };

  const prevGallery = () => {
    setCurrentGallery((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  // Testimonial navigation
  const nextTestimonial = () => {
    if (reviews.length > 0) {
      setCurrentTestimonial((prev) => (prev + 1) % reviews.length);
    }
  };

  const prevTestimonial = () => {
    if (reviews.length > 0) {
      setCurrentTestimonial((prev) => (prev - 1 + reviews.length) % reviews.length);
    }
  };

  // NEW: Event Registration Handler
  const handleEventRegistration = (registrationLink) => {
    if (registrationLink && registrationLink !== "#") {
      window.open(registrationLink, "_blank");
    }
  };

  const handleViewCalendar = () => {
    window.open(CALENDAR_URL, "_blank");
  };

  // UPDATED: Simplified Counsellors data
  const counsellors = [
    {
      name: "Sr. Rosari Sahaya Rani",
      title: "Director & Lead Counsellor",
      image: doctorImage,
      // role: "Director of Servite Counselling Centre",
      qualifications: "M.Sc. in Psychology, PG Diploma in Counselling & Psychotherapy",
      description: "Licensed Clinical Psychotherapist with extensive experience in counselling and psychotherapy."
    },
    {
      name: "Sr. Dr. Deepa BHMS",
      title: "Registered Homeopathic Practitioner",
      image: doctorImg,
      // role: "Registered Homeopathic Practitioner",
      qualifications: "Homoeopathic Medical Practitioner (BHMS)",
      description: "Professional homeopathic physician providing holistic healthcare and counselling services."
    }
  ];

  //service cards
  const serviceCards = [
    {
      title: "Psychological Counselling",
      description: "Professional therapy sessions for mental health healing and emotional wellness with certified therapists.",
      features: ["Depression", "Anxiety", "Stress", "Trauma"]
    },
    {
      title: "Couple Counselling",
      description: "Strengthen relationships, improve communication and resolve conflicts with expert guidance.",
      features: ["Marriage Issues", "Communication", "Trust Building", "Conflict Resolution"]
    },
    {
      title: "Family Counselling",
      description: "Address family conflicts, improve communication and foster deeper connections among family members.",
      features: ["Family Issues", "Parenting", "Adolescent Problems", "Elder Care"]
    }
  ];

  // Appointment form handlers
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (submitStatus) setSubmitStatus('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('sending');

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          service: formData.service,
          message: formData.message,
          time_preference: formData.timePreference,
          session_type: formData.sessionType,
          date: new Date().toLocaleDateString(),
          to_email: 'servitecouncelingcenter@gmail.com'
        },
        EMAILJS_USER_ID
      );

      setSubmitStatus('success');
      setFormData({
        name: '',
        phone: '',
        email: '',
        service: '',
        message: '',
        timePreference: 'Morning',
        sessionType: 'Offline'
      });

      setTimeout(() => setSubmitStatus(''), 5000);

    } catch (error) {
      console.error('Email sending failed:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(''), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="home-page">
      {/* Top Stats Bar - Exactly like Chennai Counseling */}
      <section className="top-stats-bar">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hero Carousel Section */}
      <section className="hero-carousel">
        <div className="carousel-container">
          <div className="carousel-wrapper">
            {carouselSlides.map((slide, index) => (
              <div
                key={index}
                className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
              >
                <img src={slide.image} alt={slide.alt} />
                <div className="slide-overlay"></div>
                <div className="slide-content">
                  <h1 className="slide-title">{slide.title}</h1>
                  <p className="slide-subtitle">{slide.subtitle}</p>
                  <button 
                    onClick={() => handleNavigation(slide.link)}
                    className="slide-cta"
                  >
                    {slide.cta} <i className="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button 
            className="carousel-control prev" 
            onClick={prevSlide}
          >
            <i className="bi bi-chevron-left"></i>
          </button>
          <button 
            className="carousel-control next" 
            onClick={nextSlide}
          >
            <i className="bi bi-chevron-right"></i>
          </button>

          <div className="carousel-dots">
            {carouselSlides.map((_, index) => (
              <button
                key={index}
                className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              ></button>
            ))}
          </div>
        </div>
      </section>

      {/* Welcome Section */}
      <section className="welcome-section">
        <div className="container">
          <div className="welcome-header">
            <h1>Cultivate Hope for Mental Well-being & Emotional Health</h1>
            <p className="welcome-subtitle">
              Servite Counselling Centre is dedicated to providing compassionate, 
              evidence-based and holistic therapeutic mental health services to individuals, 
              families and communities.
            </p>
          </div>
          
          <div className="welcome-content-centered">
            <div className="welcome-mission-vision">
              <div className="mission-block">
                <h2><i className="bi bi-bullseye"></i> Our Mission</h2>
                <p>Offer professional counselling, healing services and training programmes with compassion and respect for all individuals.</p>
              </div>
              
              <div className="vision-block">
                <h2><i className="bi bi-eye"></i> Our Vision</h2>
                <p>A centre of compassionate healing, empowerment and transformation for holistic well-being of individuals and communities.</p>
              </div>
            </div>
            
            <div className="welcome-buttons-centered">
              <button 
                onClick={() => handleNavigation("/services")}
                className="btn-primary"
              >
                <i className="bi bi-briefcase"></i> Our Services
              </button>
              <button 
                onClick={() => handleNavigation("/about")}
                className="btn-outline"
              >
                <i className="bi bi-info-circle"></i> About Us
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* NEW: Upcoming Events Section */}
      <section className="events-section">
        <div className="container">
          <div className="section-header">
            <h2>Upcoming Events & Workshops</h2>
            <p>Join our transformative programs and workshops</p>
          </div>

          <div className="events-content">
            {eventsLoading ? (
              <div className="events-loading">
                <div className="loading-spinner"></div>
                <p>Loading upcoming events...</p>
              </div>
            ) : eventsError ? (
              <div className="events-error">
                <h3>Unable to Load Events</h3>
                <p>{eventsError}</p>
                <button 
                  className="btn-calendar"
                  onClick={handleViewCalendar}
                >
                  View Calendar
                </button>
              </div>
            ) : events.length > 0 ? (
              <div className="events-grid">
                {events.slice(0, 3).map((event) => (
                  <div key={event.id} className="event-card">
                    <div className="event-content">
                      <h3>{event.title}</h3>
                      <div className="event-details">
                        <div className="detail">
                          <strong>Date:</strong> {event.date}
                        </div>
                        <div className="detail">
                          <strong>Time:</strong> {event.time}
                        </div>
                        <div className="detail">
                          <strong>Location:</strong> {event.location}
                        </div>
                      </div>
                      <p className="event-description">{event.description}</p>
                      <div className="event-actions">
                        <button 
                          className="btn-register"
                          onClick={() => handleEventRegistration(event.registrationLink)}
                        >
                          Register Now
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-events">
                <h3>No Upcoming Events</h3>
                <p>Check back soon for new workshops</p>
                <button 
                  className="btn-calendar"
                  onClick={handleViewCalendar}
                >
                  View Calendar
                </button>
              </div>
            )}
          </div>

          {/* NEW: Programs Information and Button */}
          <div className="programs-info">
            <h3>Explore Our Therapeutic Programs</h3>
            <p>We offer comprehensive therapeutic programs including Mandala Art Therapy, Study Skills Mastery, Personal Transformation Journey, Confidence Building and more specialized workshops.</p>
            <p>Each program is designed to provide practical skills, emotional healing and personal growth under expert guidance.</p>
            <button 
              onClick={() => handleNavigation("/programs")}
              className="btn-primary"
            >
              View All Programs
            </button>
          </div>
        </div>
      </section>

      {/*Superior General Message Section */}
      <section className="superior-message-image-section">
        <div className="container">
          
          <div className="message-image-container">
            <div className="message-image-card">
              <div className="section-header">
            <h2>Message from Superior General</h2>
            {/* <p>Sr. Decla Mary, MSSM - Servite Congregation</p> */}
          </div>
          
              {/* <div className="image-header">
                <h3>Message from Superior General</h3>
                <p>Sr. Decla Mary, MSSM - Servite Congregation</p>
              </div> */}
              
              <div className="message-image-wrapper">
                <img 
                  src={superiorMessageImage} 
                  alt="Official Message from Superior General Sr. Decla Mary, MSSM" 
                  className="superior-message-img"
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/800x1000/ffffff/0A2342?text=Message+from+Superior+General';
                  }}
                />
              </div>
              
              <div className="image-footer">
                <p><strong>Sr. Decla Mary, MSSM</strong></p>
                <p>Superior General, Servite Congregation</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Director's Gratitude Section */}
      <section className="gratitude-section">
        <div className="container">
          <div className="section-header">
            <h2>Message of Gratitude</h2>
            <p>From the Director, Servite Counselling Centre</p>
          </div>
          
          <div className="gratitude-content">
            <div className="gratitude-message">
              <p>
                With hearts filled with gratitude and joy, we thank God for the gift of vision and leadership 
                in Rev. Sr. Decla Mary, MSSM, our Superior General. Her dream of establishing a Counselling 
                Centre has become a living reality, enabling people to experience the healing touch and inner renewal.
              </p>
              <p>
                Through her generous support and the provision of all necessary facilities, the centre is 
                functioning effectively to help people rediscover inner happiness, hope and wellbeing.
              </p>
              <p>
                We wholeheartedly express our sincere gratitude for her constant accompaniment, guidance
                and encouragement. We humbly seek her continued blessings as we move forward in this mission 
                of healing, compassion and service.
              </p>
              
              <div className="director-quote">
                <i className="bi bi-quote"></i>
                <p>
                  "My sincere thanks to all our friends, well-wishers and benefactors for their generous 
                  support and encouragement in the successful launch of our centre's new website. Your 
                  continued goodwill and accompaniment inspire us to serve with greater commitment and compassion."
                </p>
              </div>
              
              <div className="director-signature">
                <p><strong>Director</strong></p>
                <p>Servite Counselling Centre</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="services-section">
        <div className="container">
          <div className="section-header"><br></br>
            <h2>Our Counselling Services</h2>
            <p>We provide comprehensive mental health services for individuals, couples and families</p>
          </div>
          <center>
          <div className="services-grid">
            {serviceCards.map((service, index) => (
              <div key={index} className="service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="service-features">
                  {service.features.map((feature, idx) => (
                    <span key={idx} className="feature-tag">{feature}</span>
                  ))}
                </div>
                <button 
                  onClick={() => handleNavigation("/services")}
                  className="service-btn"
                >
                  Learn More <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            ))}
          </div>
          </center>
          <div className="services-cta">
            <button 
              onClick={() => handleNavigation("/services")}
              className="btn-primary"
            >
              View All Services
            </button>
          </div>
        </div>
      </section>

      {/* UPDATED: Simplified Our Counsellors Section */}
      <section className="counsellors-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Counsellors & Therapists</h2>
            <p>Meet our dedicated team of professional counsellors</p>
          </div>
          
          <div className="counsellors-grid">
            {counsellors.map((counsellor, index) => (
              <div key={index} className="counsellor-card">
                <div className="counsellor-image-container">
                  <img src={counsellor.image} alt={counsellor.name} className="counsellor-img" />
                </div>
                <div className="counsellor-info">
                  <h3>{counsellor.name}</h3>
                  <p className="counsellor-title">{counsellor.title}</p>
                  <p className="counsellor-role">{counsellor.role}</p>
                  
                  <div className="counsellor-qualifications">
                    <p>{counsellor.qualifications}</p>
                  </div>
                  
                  <p className="counsellor-description">{counsellor.description}</p>
                  
                  <div className="counsellor-actions">
                    <button 
                      onClick={() => handleNavigation("/about")}
                      className="btn-outline"
                    >
                      Know More
                    </button>
                    <button 
                      onClick={() => handleNavigation("/contact")}
                      className="btn-primary"
                    >
                      Book Appointment
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <div className="testimonials-header">
            <h2>What do our clients say?</h2>
            <div className="testimonial-stats">
              <div className="testimonial-stat">
                <div className="stat-number">OUR</div>
                <div className="stat-label">Satisfied Clients</div>
              </div>
            </div>
          </div>
          
          <div className="testimonials-container">
            <div className="testimonials-slider">
              <div className="slider-track">
                {reviews.map((testimonial, index) => (
                  <div 
                    key={testimonial.id} 
                    className={`testimonial-slide ${index === currentTestimonial ? 'active' : ''}`}
                  >
                    <div className="testimonial-content">
                      <div className="testimonial-text">
                        "{testimonial.comment}"
                      </div>
                      <div className="testimonial-author">
                        <div className="author-info">
                          <h4>{testimonial.name}</h4>
                          <p>{testimonial.position}</p>
                        </div>
                      </div>
                      <div className="testimonial-rating">
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className={`bi bi-star-fill ${i < testimonial.rating ? "active" : ""}`}
                          ></i>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="slider-controls">
                <button 
                  className="slider-prev" 
                  onClick={prevTestimonial}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <div className="slider-dots">
                  {reviews.map((_, index) => (
                    <button
                      key={index}
                      className={`slider-dot ${index === currentTestimonial ? 'active' : ''}`}
                      onClick={() => setCurrentTestimonial(index)}
                    ></button>
                  ))}
                </div>
                <button 
                  className="slider-next" 
                  onClick={nextTestimonial}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Gallery</h2>
            <p>Explore our counselling centre and therapeutic environment</p>
          </div>
          
          <div className="gallery-container">
            <div className="gallery-slideshow">
              <div className="slideshow-wrapper">
                <div className="slideshow-container">
                  <div 
                    className="slideshow-track"
                    style={{
                      transform: `translateX(-${currentGallery * 100}%)`
                    }}
                  >
                    {galleryImages.map((image, index) => (
                      <div 
                        key={image.id} 
                        className="slideshow-slide"
                      >
                        <div className="slide-image-wrapper">
                          <img 
                            src={image.src} 
                            alt={image.alt} 
                            className="slide-img"
                            onError={(e) => {
                              e.target.src = 'https://via.placeholder.com/800x400/0A2342/ffffff?text=Counselling+Session';
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              <button 
                className="slideshow-prev" 
                onClick={prevGallery}
                aria-label="Previous image"
              >
                <i className="bi bi-chevron-left"></i>
              </button>
              <button 
                className="slideshow-next" 
                onClick={nextGallery}
                aria-label="Next image"
              >
                <i className="bi bi-chevron-right"></i>
              </button>
              
              <div className="slideshow-dots">
                {galleryImages.map((_, index) => (
                  <button
                    key={index}
                    className={`slideshow-dot ${index === currentGallery ? 'active' : ''}`}
                    onClick={() => setCurrentGallery(index)}
                    aria-label={`Go to image ${index + 1}`}
                  ></button>
                ))}
              </div>
            </div>
            
            <div className="gallery-view-all">
              <button 
                onClick={() => setShowAllGallery(!showAllGallery)}
                className="btn-primary"
              >
                {showAllGallery ? (
                  <>
                    <i className="bi bi-play-circle"></i> Show Slideshow
                  </>
                ) : (
                  <>
                    <i className="bi bi-grid-3x3"></i> View All Photos 
                  </>
                )}
              </button>
            </div>
            
            {showAllGallery && (
              <div className="gallery-grid-view">
                <div className="grid-header">
                  <h3>All Photos ({galleryImages.length})</h3>
                </div>
                <div className="image-grid">
                  {galleryImages.map((image) => (
                    <div key={image.id} className="grid-item">
                      <div className="grid-image-wrapper">
                        <img 
                          src={image.src} 
                          alt={image.alt} 
                          className="grid-img"
                          onError={(e) => {
                            e.target.src = 'https://via.placeholder.com/300x200/0A2342/ffffff?text=Counselling';
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Appointment Section */}
      <section className="appointment-section">
        <div className="container">
          <div className="section-header">
            <h2>Book Your Appointment</h2>
            <p>Schedule a counselling session with our expert therapists</p>
          </div>
          
          <div className="appointment-container">
            <div className="appointment-info">
              <h3>Contact Information</h3>
              
              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div className="contact-text">
                    <h4>Address</h4>
                    <p>
                      Servite Counselling Centre,<br />
                      Near Holycross College, Vattakarai,<br />
                      Nagercoil, Tamil Nadu, India
                    </p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div className="contact-text">
                    <h4>Phone</h4>
                    <p>+91 8148 600 633</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="bi bi-envelope"></i>
                  </div>
                  <div className="contact-text">
                    <h4>Email</h4>
                    <p>servitecounselingcentre@gmail.com</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="bi bi-clock"></i>
                  </div>
                  <div className="contact-text">
                    <h4>Working Hours</h4>
                    <p>Monday - Saturday: 9:30 AM - 7:00 PM</p>
                    
                  </div>
                </div>
              </div>
            </div>
            
            <div className="appointment-form">
              <h3>Book Your Session</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Your Name"
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Phone Number"
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address"
                    disabled={isSubmitting}
                  />
                </div>
                
                <div className="form-group">
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    required
                    disabled={isSubmitting}
                  >
                    <option value="">Select Service Required</option>
                    {services.map((service, index) => (
                      <option key={index} value={service}>{service}</option>
                    ))}
                  </select>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <select
                      name="sessionType"
                      value={formData.sessionType}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                    >
                      <option value="Offline">Offline Session</option>
                      <option value="Online">Online Session</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <select
                      name="timePreference"
                      value={formData.timePreference}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                    >
                      <option value="Morning">Morning (9:30 AM - 12:00 PM)</option>
                      <option value="Evening">Evening (4:00 PM - 7:00 PM)</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Additional Information (Optional)"
                    rows="3"
                    disabled={isSubmitting}
                  ></textarea>
                </div>
                
                {submitStatus === 'success' && (
                  <div className="form-success">
                    <i className="bi bi-check-circle"></i>
                    <span>Appointment request submitted successfully!</span>
                  </div>
                )}
                
                {submitStatus === 'error' && (
                  <div className="form-error">
                    <i className="bi bi-exclamation-circle"></i>
                    <span>Failed to submit. Please try again or call us.</span>
                  </div>
                )}
                
                <div className="form-submit">
                  <button 
                    type="submit" 
                    className="btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Processing...' : 'Book Appointment'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Begin Your Healing Journey?</h2>
            <p>Contact us today to schedule your first counselling session</p>
            <div className="cta-buttons">
              <button 
                onClick={() => handleNavigation("/contact")}
                className="btn-primary"
              >
                <i className="bi bi-calendar-check"></i> Book Appointment
              </button>
              <button 
                onClick={() => window.location.href = 'tel:+918148600633'}
                className="btn-outline"
              >
                <i className="bi bi-telephone"></i> Call Now
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;